import { Component, inject } from '@angular/core';
import {
  GcModalComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { SelectSpanModeService } from '../../../service/map/span/select-span-mode/select-span-mode.service';
import { spanColorGuideDataMultiSpan } from '../span-color-guide/span-color-guide-data';
import { SpanColorGuideComponent } from '../span-color-guide/span-color-guide.component';

@Component({
  selector: 'app-help-modal',
  imports: [
    GcModalComponent,
    IpoTranslatePipe,
    GcTextComponent,
    SpanColorGuideComponent,
  ],
  templateUrl: './help-modal.component.html',
  styleUrl: './help-modal.component.scss',
})
export class HelpModalComponent {
  private readonly selectSpanModeService = inject(SelectSpanModeService);

  spanColorGuideData = spanColorGuideDataMultiSpan;

  closeModal = () => {
    this.selectSpanModeService.setIsMultiSpanHelpModalOpen(false);
  };
}
